// extracted by mini-css-extract-plugin
module.exports = {"root":"EEBJXb","success":"Dto3DO","error":"c6yxscQ","text":"ubyrEA"};